module.exports = __webpack_public_path__ + "img/irvia.d7c6ac20.png";